var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"statement"},[_c('dt',{staticClass:"statement__tit"},[_vm._v(_vm._s(_vm.title))]),_c('dd',{class:['statement__content', _vm.contentCurrentClassName]},[_vm._t("statement-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }